import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import type { State } from 'state';
import { getPathname, getPortalId } from 'state/selectors/context';
import { getIsAnonymousEnabled } from 'state/selectors/env';
import {
    getHelpCenterTopBarColor,
    getHelpCenterTopBarSplitFlag,
    getLogoUrl,
    getSharedPortalName,
} from 'state/selectors/help-center';
import { isCustomizing } from 'state/selectors/help-center-preview';
import { getOrganisations } from 'state/selectors/organisations';
import { isLoggedIn, isUserLoaded } from 'state/selectors/user';
import { getUserRequestsCounts } from 'state/selectors/user-requests-counts';
import { getLoginUrl } from '@atlassian/help-center-common-util/url';
import { LayoutHeader } from './layout-header';

const getHeaderLoginUrl = (state: State) => {
    const portalId = getPortalId(state);
    return getLoginUrl({
        portalId,
        isAbsolute: true,
        redirectUrl: getPathname(state),
    });
};

const userRequestsSelector = (state: State) => {
    return getUserRequestsCounts(state);
};

const selector = createSelector(
    isLoggedIn,
    getHeaderLoginUrl,
    isUserLoaded,
    isCustomizing,
    userRequestsSelector,
    getOrganisations,
    getIsAnonymousEnabled,
    getHelpCenterTopBarColor,
    getHelpCenterTopBarSplitFlag,
    getLogoUrl,
    getSharedPortalName,
    (
        userLoggedIn,
        loginUrl,
        userLoaded,
        customizing,
        userRequest,
        organisations,
        anonymousEnabled,
        topBarColor,
        hasTopBarBeenSplit,
        logoUrl,
        name
    ) => ({
        hasTopBarBeenSplit,
        headerProps: {
            userLoggedIn,
            loginUrl,
            userRequest,
            organisations,
            anonymousEnabled,
            isUserLoaded: userLoaded,
            isCustomizing: customizing,
            headerBackgroundColor: hasTopBarBeenSplit ? topBarColor : undefined,
            logoUrl: logoUrl ?? undefined,
            name: name ?? undefined,
        },
    })
);

export default connect(selector, {})(LayoutHeader);
